import {useRef} from "react";
import ReminderConfigurer, { Reminder as ReminderType, createReminder } from "../data/Reminder";
import AddIcon from '@mui/icons-material/Add';


type props = {
    reminderList: ReminderType[];
    setReminderList: (reminderlist: ReminderType[]) => void;
    save: () => void;
}

const ReminderList: React.FC<props> = ({ reminderList, setReminderList, save}: props) => {
    const originalReminderListRef = useRef<ReminderType[]>(JSON.parse(JSON.stringify(reminderList)));

    // Deep comparison of reminder lists
    const areReminderListsEqual = (list1: ReminderType[], list2: ReminderType[]) => {
        if (list1.length !== list2.length) return false;
        return list1.every((reminder, index) => {
            const otherReminder = list2[index];
            return JSON.stringify(reminder) === JSON.stringify(otherReminder);
        });
    };

    const unsavedChanges = !areReminderListsEqual(originalReminderListRef.current, reminderList);

    const handleSave = () => {
        save();
        originalReminderListRef.current = JSON.parse(JSON.stringify(reminderList));
    };

    const updateReminder = (newReminder: ReminderType, index: number) => {
        const newList = [...reminderList];
        newList[index] = newReminder;
        setReminderList(newList);   
    }
    
    const deleteReminder = (index: number) => {
        const newList = [...reminderList];
        newList.splice(index, 1);
        setReminderList(newList);
    }

    const createNewReminder = () => {
        setReminderList([...reminderList, createReminder()]);
    }

    //TODO: Sort reminders by date
    
    return (
        <div className="reminder-list">
            {reminderList.map((reminder: ReminderType, index: number) => (
                <ReminderConfigurer key={`reminder-${index}`} 
                reminder={reminder} 
                setReminder={(newReminder) => updateReminder(newReminder, index)}
                deleteSelf={() => deleteReminder(index)}
                />
            ))}
            <div className="trip-list-footer">
                <button className='add-trip button-transparent' onClick={createNewReminder}>
                    <AddIcon/> Hinzufügen
                </button>
                <button className='save button-transparent' onClick={handleSave} disabled={!unsavedChanges}>Speichern</button>
            </div>
        </div>
    );
}

export default ReminderList;